import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
// import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Row, Spinner } from "reactstrap";
import logoD from "../assets/img/logoDark.png";
import logo from "../assets/img/logoWhite.png";
import { signUpAction } from "../store/actions/authAction";
import InputFields from "./InputFields";

const SignUpForm = () => {
  const outerTheme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { darkMode, color } = useSelector((state) => state.global);
  const { loading } = useSelector((state) => state.user);
  const inputColor = darkMode ? "#ffffff" : "rgb(101 92 92)";
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [signUpData, setSignUpData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    age: "",
    DOB: "",
    gender: "",
    darkMode: false,
    mainColor: "#d70365",
  });

  const labelProps = {
    style: {
      color: darkMode ? "#ffffff" : "rgb(101 92 92)",
    },
  };

  const clearFormData = () => {
    setSignUpData({
      name: "",
      contactNumber: "",
      email: "",
      password: "",
      confirmPassword: "",
      address: "",
      age: "",
      DOB: "",
      gender: "",
      darkMode: false,
      mainColor: "#d70365",
    });
  };

  const customTheme = (outerTheme) =>
    createTheme({
      palette: {
        mode: outerTheme.palette.mode,
      },
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              borderColor: inputColor,
            },
            root: {
              [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: "#000000",
              },
              [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: `${color || "#000000"}`,
              },
            },
          },
        },
      },
    });

  const handleChangeData = (e) => {
    const { name, value } = e.target;

    if (name === "DOB") {
      const selectedDate = new Date(value);
      const currentDate = new Date();

      if (selectedDate > currentDate) {
        toast.error(`Date must be today or earlier`);
        return;
      }
      handleAge(value);
    }

    setSignUpData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calculateAge = (dateOfBirth) => {
    var birthday = new Date(dateOfBirth);

    if (isNaN(birthday.getTime())) {
      return null;
    }

    var today = new Date();
    var age = today.getFullYear() - birthday.getFullYear();
    var monthDifference = today.getMonth() - birthday.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthday.getDate())
    ) {
      age--;
    }

    return age;
  };

  const handleAge = (value) => {
    const ageValue = calculateAge(value);
    if (ageValue) {
      setSignUpData((obj) => ({ ...obj, age: Number(ageValue) }));
    }
  };

  const validateEmail = (email) => {
    return (
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) &&
      !email.includes(" ")
    );
  };
  const handleEmailChange = (e) => {
    const { value, name } = e.target;
    setSignUpData((obj) => ({
      ...obj,
      [name]: value,
    }));
    setEmailError("");
  };

  const validatePassword = (password) => {
    return (
      password?.length >= 6 &&
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/.test(password) &&
      /\d/.test(password) &&
      !password.includes(" ")
    );
  };
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setSignUpData((obj) => ({
      ...obj,
      [name]: value,
    }));
    setPasswordError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateEmail(signUpData.email)) {
      setEmailError(
        "Please enter a valid email address (e.g., user@example.com)"
      );
      return;
    }
    if (!validatePassword(signUpData.password)) {
      setPasswordError(
        "Password must be at least 6 characters long, include at least one digit, and a special character"
      );
      return;
    }
    if (signUpData.password !== signUpData.confirmPassword) {
      toast.error("Password and Confirm Password do not match.");
      return;
    }
    dispatch(
      signUpAction(signUpData, () => {
        history.push("/auth");
        clearFormData();
      })
    );
  };

  return (
    <>
      <ThemeProvider theme={customTheme(outerTheme)}>
        <Form className="px-2 mt-1" onSubmit={handleSubmit}>
          <Row className="mb-5 justify-content-center position-relative">
            {}
            <img
              alt="image_upload"
              src={darkMode === true ? logo : logoD}
              className="image_upload__arrow"
              width="60px"
            />
          </Row>

          <InputFields
            labelName={"Full Name"}
            type={"text"}
            name={"name"}
            value={signUpData.name}
            labelProps={labelProps}
            inputColor={inputColor}
            handleChangeData={handleChangeData}
            darkMode={darkMode}
          />

          <InputFields
            labelName={"Phone No."}
            type={"phone"}
            name={"contactNumber"}
            value={signUpData.contactNumber}
            labelProps={labelProps}
            inputColor={inputColor}
            handleChangeData={handleChangeData}
            darkMode={darkMode}
            defaultCountry="US"
          />

          <InputFields
            labelName={"Email"}
            type={"email"}
            name={"email"}
            value={signUpData.email}
            labelProps={labelProps}
            inputColor={inputColor}
            autoComplete="off"
            error={emailError}
            helperText={emailError}
            handleChangeData={handleEmailChange}
            darkMode={darkMode}
          />

          <InputFields
            labelName={"Password"}
            type={"password"}
            name={"password"}
            value={signUpData.password}
            error={passwordError}
            helperText={passwordError}
            labelProps={labelProps}
            autoComplete="off"
            inputColor={inputColor}
            handleChangeData={handlePasswordChange}
          />

          <InputFields
            labelName={"Confirm Password"}
            type={"password"}
            name={"confirmPassword"}
            value={signUpData.confirmPassword}
            autoComplete="off"
            error={passwordError}
            helperText={passwordError}
            labelProps={labelProps}
            inputColor={inputColor}
            handleChangeData={handleChangeData}
          />

          <InputFields
            labelName={"Address"}
            type={"text"}
            name={"address"}
            value={signUpData.address}
            labelProps={labelProps}
            inputColor={inputColor}
            handleChangeData={handleChangeData}
            darkMode={darkMode}
          />

          <InputFields
            labelName={"DOB"}
            type={"date"}
            name={"DOB"}
            value={signUpData.DOB}
            labelProps={labelProps}
            inputColor={inputColor}
            handleChangeData={handleChangeData}
            darkMode={darkMode}
          />

          <FormControl required fullWidth>
            <InputLabel
              style={{
                color: darkMode ? "#ffffff" : "rgb(101 92 92)",
              }}
              id="demo-simple-select-required-label"
            >
              Gender
            </InputLabel>
            <Select
              sx={{
                borderColor: inputColor,
              }}
              required
              labelId="demo-simple-select-required-label"
              id="demo-simple-select-required"
              className="mb-4"
              label="Gender *"
              name="gender"
              value={signUpData.gender}
              onChange={(e) => handleChangeData(e)}
              color="secondary"
              style={{
                color: inputColor,
              }}
              InputProps={{
                style: {
                  color: inputColor,
                },
              }}
              InputLabelProps={labelProps}
              variant="outlined"
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
            </Select>
          </FormControl>

          {}
          <Button
            className="py-3 mt-3 w-100 auth__btn pointer"
            style={{ background: `${color}` }}
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : `${"Sign Up"}`}
          </Button>
          {}
          <p className="mt-3 text-center" style={{ color: inputColor }}>
            Already have an account?{" "}
            <span
              className="cursor-pointer"
              style={{ color: `${color}` }}
              onClick={() => history.push("/auth")}
            >
              Login Now
            </span>
          </p>
        </Form>
      </ThemeProvider>
    </>
  );
};

export default SignUpForm;
